module.exports = __webpack_public_path__ + "img/left_arrow.fad43731.svg";